import React from 'react';

export const RightArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="#3A4D5F" viewBox="0 0 1000 1000"><path d="M750.3 450.6L345.1 30.5c-26.3-27.3-69-27.3-95.4 0 -26.3 27.3-26.3 71.5 0 98.8L607.3 500 249.7 870.7c-26.3 27.3-26.3 71.6 0 98.8 26.3 27.3 69 27.3 95.4 0l405.2-420.1C776.6 522.1 776.6 477.9 750.3 450.6z"/></svg>
);

export const WonderblyLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="49" viewBox="-83 114.5 117 56"><path fill="#2CB492" d="M.1 114.6l-13.6 13L1 141.5v-26.6c0-.4-.6-.6-.9-.3zm-36.6 13l-13.6-13c-.3-.3-.9-.1-.9.3v26.6l14.5-13.9z"/><path fill="#80D2BE" d="M-51 141.5H1l-25.3-24.7c-.4-.4-1-.4-1.4 0L-51 141.5z"/><path fill="#2CB492" d="M18.6 163.9h1.6c.2 0 .6-.1.6-.6v-1.7c0-.4-.3-.5-.5-.5h-.7c-.4 0-.7-.3-.7-.7v-12.2c0-.3-.2-.5-.5-.5h-2.3c-.3 0-.5.2-.5.5v12.9c.1 1.7.9 2.8 3 2.8zM8.5 152.3c-1.5 0-2.8.6-3.3 1.5v-5.6c0-.3-.2-.5-.5-.5H2.3c-.3 0-.5.2-.5.5v15.3c0 .3.2.5.5.5h2.3c.3 0 .5-.2.5-.5v-.6c.6.9 1.9 1.5 3.3 1.5 3 0 5.6-2.3 5.6-6 .1-3.8-2.6-6.1-5.5-6.1zm-.6 8.9c-1.6 0-2.8-1.3-2.8-2.9s1.2-2.9 2.8-2.9c1.6 0 2.8 1.3 2.8 2.9s-1.2 2.9-2.8 2.9zm-8.4-8.7c-1.1 0-2.1.6-2.7 1.6v-.9c0-.3-.3-.5-.5-.5h-2.2c-.3 0-.5.2-.5.5v10.3c0 .3.2.5.5.5h2.3c.3 0 .5-.2.5-.5v-5c0-1.7.8-2.4 2.2-2.4h.6c.2 0 .6-.1.6-.6v-2.3c0-.5-.3-.6-.6-.6l-.2-.1zm-13.3-.2c-3.5 0-6 2.7-6 6 0 3.6 2.6 5.9 6 5.9 2.6 0 4-1 4.8-2 .2-.2.2-.5-.1-.7l-1.4-1.3c-.2-.2-.5-.2-.7 0-.7.7-1.5 1.1-2.6 1.1-1.3 0-2.4-.9-2.6-2.3h7.8c.5 0 .6-.3.6-.5v-.6c0-2.9-2.1-5.6-5.8-5.6zm-2.4 4.7c.3-1.3 1.3-2 2.5-2 1.1 0 2.2.6 2.5 2h-5zm-5.7-9.4h-2.3c-.3 0-.5.2-.5.5v5.6c-.5-.8-1.8-1.5-3.3-1.5-2.9 0-5.6 2.3-5.6 6 0 3.6 2.7 6 5.6 6 1.5 0 2.6-.6 3.3-1.5v.7c0 .3.2.5.5.5h2.3c.3 0 .5-.2.5-.5v-15.3c0-.2-.2-.5-.5-.5zm-5.5 13.6c-1.6 0-2.8-1.3-2.8-2.9s1.2-2.9 2.8-2.9c1.6 0 2.8 1.3 2.8 2.9s-1.3 2.9-2.8 2.9zm-11.2 2.2c0 .3.3.5.5.5h2.3c.3 0 .5-.2.5-.5v-6.3c0-2.8-1.9-4.9-4.9-4.9-1.8 0-3 .7-3.7 1.5v-.7c0-.3-.3-.5-.5-.5h-2.3c-.3 0-.5.2-.5.5v10.3c0 .3.2.5.5.5h2.3c.3 0 .5-.2.5-.5V158c0-1.6 1.1-2.7 2.6-2.7 1.6 0 2.5 1.1 2.5 2.7l.2 5.4zm-16.1-11.2c-3.4 0-6.1 2.6-6.1 6 0 3.3 2.8 6 6.1 6 3.4 0 6.1-2.6 6.1-6 .1-3.3-2.7-6-6.1-6zm0 8.9c-1.6 0-2.8-1.3-2.8-2.9s1.2-2.9 2.8-2.9c1.6 0 2.8 1.3 2.8 2.9 0 1.6-1.2 2.9-2.8 2.9zm88.5-7.7c.2-.5 0-.8-.4-.8H31c-.4 0-.5.3-.6.5l-2.6 6.7-2.9-6.7c-.2-.4-.3-.5-.6-.5h-2.6c-.6 0-.7.4-.5.8l4.4 9.4.5 1.1-1.2 2.6c-.3.6-.7 1.1-1.6 1.1H23c-.2 0-.5.1-.5.5v1.8c0 .5.4.6.6.6h.4c2.3 0 3.5-1.3 4.4-3.5l5.9-13.6zm-94.5-5.8h-2.6c-.3 0-.5.3-.5.5l-2.6 11.5-2.8-9.2c-.1-.4-.5-.7-1-.7h-2.4c-.5 0-.9.3-1 .7l-2.8 9.3-2.6-11.5c-.1-.3-.3-.5-.5-.5h-2.8c-.4 0-.7.3-.6.8l3.8 14.9c.1.4.4.5.6.5h3.9c.2 0 .5-.1.6-.5l2.6-8.5 2.6 8.5c.1.4.4.5.6.5h3.7c.1 0 .6-.1.6-.5l3.7-14.9c.2-.7-.2-.9-.5-.9z"/></svg>
);

export const WonderblyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="52" height="27" viewBox="0 0 52 27"><path strokeWidth="3" fill="#2CB492" d="M51.1.14420707L37.5 13.1228431 52 27V.44371405c0-.39934264-.6-.59901397-.9-.29950698zM14.5 13.1228431L.9.14420707C.6-.15529993 0 .0443714 0 .44371405V27l14.5-13.8771569z"/><path fill="#80D2BE" d="M0 27h52L26.7 2.3c-.4-.4-1-.4-1.4 0L0 27z"/></svg>
);

export const CaretLeft = () => (
  <svg width="10" height="17" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.193 15.322a.682.682 0 0 0-.209-.476L2.646 8.51 8.984 2.17a.682.682 0 1 0-.964-.965L1.2 8.026a.682.682 0 0 0 0 .965l6.82 6.82a.682.682 0 0 0 1.173-.49z"
      fill="#B5BCC3"
      fillRule="nonzero"
      stroke="#B5BCC3"
    />
  </svg>
);

export const CaretRight = () => (
  <svg width="10" height="17" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.183 1.285c.004.18.08.35.209.475L7.73 8.098l-6.338 6.338a.682.682 0 1 0 .964.964l6.82-6.82a.682.682 0 0 0 0-.964L2.356.796a.682.682 0 0 0-1.173.489z"
      fill="#B5BCC3"
      fillRule="nonzero"
      stroke="#B5BCC3"
    />
  </svg>
);

export const Hamburger = () => (
  <svg
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    style={{ height: '1em', width: '1em' }}>
    <path
      d="M6 36h36v-4H6v4zm0-10h36v-4H6v4zm0-14v4h36v-4H6z"
      fill="currentColor"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/client/js/view/components/SVGs/index.js